import React, { Component } from 'react';
import classNames from 'classnames';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data, Editors } from 'react-data-grid-addons';
import {SkyLightStateless} from 'react-skylight';
import { UI_HEIGHT } from '../Common/constants';
import { Grid, Row, Col, Panel, Button, DropdownButton, MenuItem, FieldGroup, Input } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import { Field, FieldArray, reset } from 'redux-form';
import Selection from '../Common/selection';
import { InputField, DisabledInputField, ControlledInputField } from '../Common/inputField';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';

import CustomerItems from '../../containers/Returns/customerItems';

var DropDownEditor = Editors.DropDownEditor;

class CreditForm extends Component{
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            invoice: {
              rows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null,
            },
            totalPrice: 0,
            chooseItemOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        const { currentSalesInvoice } = this.props;
        if(!currentSalesInvoice) {
          this.props.fetchCustomerItem(this.props.currentCustomer.value);
        }
        else if(typeof currentSalesInvoice == "object" && currentSalesInvoice.SalesReturn_id != null){
          this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
        }
        else if(typeof currentSalesInvoice == "object")
          this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoiceCompleted_id);
        else
          this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, "InvoiceNum");
        // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
      if(nextProps.customerItem && nextProps.customerItem != this.props.customerItem) {
      }
        if (nextProps.salesInvoiceDetail && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
          let newRows = nextProps.salesInvoiceDetail.Sales_Invoice_Line_Complete;
          let invoice = {...this.state.invoice, rows: newRows };
          this.setState({ invoice });
        }
        if(nextProps.salesReturnDetail && nextProps.salesReturnDetail != this.props.salesReturnDetail) {
          let invoice = {...this.state.invoice, rows: nextProps.salesReturnDetail.Sales_Return_Line };
          this.setState({ invoice, totalPrice: nextProps.salesReturnDetail && nextProps.salesReturnDetail.TotalPrice });
        }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton});
    }

    formatDate(date) {
      let formattedDate = date.getFullYear() + '-';

      formattedDate += date.getMonth()+1 + '-';
      if (date.getDate() < 10) {
        formattedDate += '0' + date.getDate();
      } else {
        formattedDate += date.getDate();
      }
      return formattedDate;
    }

    renderInvoice() {
      if (this.props.isLoading && !this.props.error) return <Spinner/>
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.invoice);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var invoice = {...this.state.invoice, sortColumn: sortColumn, sortDirection: sortDirection};
              this.setState({ invoice });
          }

          // const onRowSelect = rows => {
          //     var POs = {...this.state.previousOrders, selectedRows: rows};
          //     this.setState({previousOrders});
          // }

          const handleRowUpdated = e => {
            let rows = getRows();
            let returnTotalPrice = parseFloat(rows[e.rowIdx].ReturnTotalPrice) || 0;
            Object.assign(rows[e.rowIdx], e.updated);
            if(e.cellKey == "ReturnTotalPrice"){
              let percentOff = rows[e.rowIdx].UnitPrice ? (100 + ((parseFloat( e.updated.ReturnTotalPrice)|| 0)/(parseFloat(rows[e.rowIdx].UnitPrice) || 0)/(parseFloat(rows[e.rowIdx].ReturnQuantity)|| 0))*100) : 0;
              Object.assign(rows[e.rowIdx], {PercentOff: percentOff});
              let totalPrice = (parseFloat(this.state.totalPrice) || 0) + (parseFloat(e.updated.ReturnTotalPrice) || 0) - returnTotalPrice;
              totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
              this.setState({totalPrice: totalPrice})
            }
            if(e.cellKey == "ReturnQuantity"){
              let newReturnTotalPrice = -(parseFloat(e.updated.ReturnQuantity) || 0)*(parseFloat(rows[e.rowIdx].UnitPrice) || 0)
              Object.assign(rows[e.rowIdx], {PercentOff: 0, ReturnTotalPrice: newReturnTotalPrice});
              let totalPrice = (parseFloat(this.state.totalPrice) || 0) + (parseFloat(rows[e.rowIdx].ReturnTotalPrice) || 0) - returnTotalPrice;
              totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
              this.setState({totalPrice: totalPrice})
            }
          }

          const onRowsSelected = (rows) => {
               let newRows = this.state.invoice.rows;
               rows.map (r => {
                 newRows[r.rowIdx].isSelected = true;
               });
              //  this.setState({rows: newRows});
          }

           const onRowsDeselected = (rows) => {
               let newRows = this.state.invoice.rows;
               rows.map (r => {
                 newRows[r.rowIdx].isSelected = false;
               });
              //  this.setState({rows: newRows});
           }

          var creditReasonOptions = [
            'Product Damaged',
            'Item Defective',
            'Missing Parts',
            'Shortage',
            'Missing',
            'Others',
            'Out',
            'Short',
          ];

          // Column difinition

          const columns = [
            {
                key: 'ProductNum',
                name: <Translate value="product_num" />,
                resizable: true,
                sortable: true,
                width: 160,
                filterable: true
            },
            {
                key: 'ProductName',
                name: <Translate value="name" />,
                resizable: true,
                sortable: true,
                width: 160,
                filterable: true,
            },
            {
                key: 'ProductDescription',
                name: <Translate value="description" />,
                resizable: true,
                sortable: true,
                width: 160,
                filterable: true,
            },
            {
                key: 'Quantity',
                name: <Translate value="quantity" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true
            },
            {
                key: 'UnitPrice',
                name: <Translate value="unit_price" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'ReturnQuantity',
                name: <Translate value="return_quantity" />,
                resizable: true,
                sortable: true,
                editable: true,
                width: 150,
                filterable: true
            },
            {
                key: 'PercentOff',
                name: <Translate value="percentsign_off" />,
                resizable: true,
                sortable: true,
                width: 150,
                filterable: true
            },
            {
                key: 'ReturnTotalPrice',
                name: <Translate value="total_price" />,
                editable: true,
                resizable: true,
                sortable: true,
                width: 150,
                filterable: true
            },
            {
                key: 'ReturnReason',
                name: <Translate value="credit_reason" />,
                resizable: true,
                sortable: true,
                editable: true,
                editor: <DropDownEditor options={ creditReasonOptions }/>,
                width: 150,
                filterable: true
            }
          ]

          return (
              <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="CreditForm-dataGrid1">
                  <ReactDataGrid
                      rowKey='Product_id'
                      onGridSort={handleGridSort}
                      columns={columns}
                      rowHeight={25}
                      rowGetter={rowGetter}
                      rowsCount={getSize() }
                      enableCellSelect={true}
                      onRowUpdated={handleRowUpdated}
                      minHeight={this.state.tableHeight}
                      enableRowSelect='multi'
                      rowSelection={{
                        showCheckbox: true,
                        enableShiftSelect: true,
                        onRowsSelected: onRowsSelected,
                        onRowsDeselected: onRowsDeselected,
                        selectBy: {
                         isSelectedKey: 'isSelected'
                        }
                     }}
                      />
              </div></Col></Row>
          )
      }
    }

    handleFormSubmit(formProps) {
      if(this.props.salesReturnDetail) {
        if(!this.checkPermission("change_sales_return"))
          this.props.editSalesReturn(formProps, this.props.salesReturnDetail, this.state.totalPrice, this.state.invoice.rows);
        else
          alert("You have no permission!");
      }
      else{
        let salesInvoiceDetail = {};
        this.props.createSalesReturn(formProps, this.props.salesInvoiceDetail || salesInvoiceDetail, this.state.totalPrice, this.state.invoice.rows, this.props.currentCustomer, "Credit");
      }
    }

    addNonProduct() {
        let invoice = {...this.state.invoice};
        let r = { ProductNum: "N/A", ProductName: "Non-Product" }
        invoice.rows.push(r);
        this.setState({invoice});
    }

    closeChooseItem() {
      this.setState({chooseItemOpen: false})
    }

    openChooseItem() {
      this.setState({chooseItemOpen: true})
    }

    addItem(r) {
      let newRows = [...this.state.invoice.rows];
      newRows = newRows.concat(r);
      let invoice = {...this.state.invoice, rows: newRows};
      this.setState({invoice: invoice});
    }

    render() {
        const salesInvoiceDetail = this.props.salesInvoiceDetail;
        const { handleSubmit } = this.props;
        let finalPrice = 0;
        let createDialogStyle = {
            height: '600px',
            width: '600px',
            marginLeft: '-10%',
        };
        return (
          <ContentWrapper>
            <div className="content-heading"><Translate value="customer_credit" /></div>
            <br/>
            <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
            <Row><Link to="/customerReturn" className="btn btn-default pull-right"><em className="fa fa-close"/></Link></Row>
            <Row>
                <Col sm = { 4 }>
                    <Row><label><Translate value="customer_num_colonsign" /></label></Row>
                    <Row><label><Translate value="customer_name_colonsign" /></label> {salesInvoiceDetail && salesInvoiceDetail.Customer_Name} </Row>
                    <Row><label><Translate value="sales_colonsign" /></label></Row>
                </Col>
                <Col sm = { 4 }>
                    <Row><label><Translate value="invoice_no_colonsign" /></label> {salesInvoiceDetail && salesInvoiceDetail.InvoiceNum} </Row>
                    <Row><label><Translate value="invoice_date_colonsign" /></label> {salesInvoiceDetail && salesInvoiceDetail.PostingDate.slice(0, 10)} </Row>
                    <Row><label><Translate value="total_price_colonsign" /></label> {salesInvoiceDetail && salesInvoiceDetail.TotalPrice} </Row>
                </Col>
                <Col sm = { 4 }></Col>
            </Row>
            <Row>
              <Col>
                <Button className="btn btn-primary pull-right" onClick={ this.addNonProduct.bind(this) }>
                  <Translate value="add_non_product" />
                </Button>
                <Button className="btn btn-primary" onClick={ this.openChooseItem.bind(this) } style={{float: "right"}}><i/> <Translate value="msg_select_an_item" />
                </Button>
              </Col>
            </Row>
            <Row>
              { this.renderInvoice() }
            </Row>
            <Row>
              <Col sm = { 8 }>
                <Panel>
                  <label className="col-sm-5 marginTopStyle" ><Translate value="note" /></label>
                  <Field name="Note" component="Textarea" className="form-control" style={{ minHeight: '100px' }}/>
                </Panel>
              </Col>
              <Col sm = { 4 }>
                <Row><label><Translate value = "final_dollarsign" />:</label> {this.state.totalPrice}</Row>
              </Col>
            </Row>
            <br/>
            <Row>
              <Button className="btn btn-primary pull-left" type="submit"><Translate value="issue_credit" /></Button>
            </Row>
          </form>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.chooseItemOpen} onCloseClicked={
              this.closeChooseItem.bind(this)} title={<Translate value="choose_an_item" />}>
              <CustomerItems items={this.props.customerItem} addItem={this.addItem.bind(this)}/>
          </SkyLightStateless>
          </ContentWrapper>
        )
    }
}

export default CreditForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/creditForm.jsx